import {NgForOf, NgIf} from '@angular/common';
import {Component, Input} from '@angular/core';
import {NbIconModule, NbTooltipModule} from '@nebular/theme';
import {ProductCustomer} from 'compob2b-libs';

@Component({
    selector: 'app-product-markers',
  imports: [
    NbTooltipModule,
    NgForOf,
    NgIf,
    NbIconModule
  ],
    templateUrl: './product-markers.component.html',
    styleUrl: './product-markers.component.scss'
})
export class ProductMarkersComponent {
  @Input() product: ProductCustomer;

  /**
   * CMZ-374: opt-in to the cart mockup's layout — tags sit in the flow as a left-aligned row
   * under (desktop) or above (mobile) the product name, sized by their own text. Left false so
   * the five other screens keep the absolute-positioned flag column they were built around.
   */
  @Input() inline = false;

  get isSimilarPhoto(): boolean {
    return undefined !== this.product.markers && null !== this.product.markers && -1 !== this.product.markers.findIndex(item => 11 === item.id);
  }

  get similarPhotoText(): string {
    if (undefined !== this.product.markers && null !== this.product.markers) {
      const index = this.product.markers.findIndex(item => 11 === item.id);
      if (-1 !== index) {
        return this.product.markers[index].header;
      }
    }
    return "";
  }
}
